import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Droplets, Lock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("hw_admin_token", data.token);
      localStorage.setItem("hw_admin_email", data.email);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5"
      style={{ background: "linear-gradient(160deg,#0f4c81,#0c3251)" }}>
      <form onSubmit={handleSubmit} data-testid="admin-login-form"
        className="bg-white rounded-3xl p-8 w-full max-w-md shadow-2xl">
        <div className="flex items-center gap-2 justify-center mb-6">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: "#0f4c81" }}>
            <Droplets className="w-6 h-6 text-white" />
          </div>
          <span className="font-heading font-extrabold text-[#0f4c81] text-xl">Admin Login</span>
        </div>

        <label className="hw-label" htmlFor="admin-email">Email</label>
        <input id="admin-email" data-testid="admin-email" className="hw-input" type="email"
          value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" required />

        <label className="hw-label mt-4" htmlFor="admin-password">Password</label>
        <input id="admin-password" data-testid="admin-password" className="hw-input" type="password"
          value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />

        {error && <p data-testid="admin-login-error" className="text-red-500 text-sm mt-3">{error}</p>}

        <button type="submit" data-testid="admin-login-button" className="btn-cta w-full mt-6" disabled={loading}>
          {loading ? <><Loader2 className="w-5 h-5 animate-spin" /> Signing in...</> : <><Lock className="w-4 h-4" /> Sign In</>}
        </button>
      </form>
    </div>
  );
}
